import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

import {TranslatePipe} from '@brunata-angular/util';
import {
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import {VariableAlarmWithTranslations} from '../variable-alarm.model';

@Component({
    selector: 'app-variable-alarms-card-view',
    standalone: true,
    imports: [TranslatePipe, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle],
    templateUrl: './variable-alarms-card-view.component.html',
    styleUrl: './variable-alarms-card-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VariableAlarmsCardViewComponent {
    @Input() variableAlarms: VariableAlarmWithTranslations[] = [];
    @Output() deleteVariableAlarm: EventEmitter<VariableAlarmWithTranslations> =
        new EventEmitter<VariableAlarmWithTranslations>();
    @Output() editAlarm: EventEmitter<string | null> = new EventEmitter<string | null>();
    @Output() duplicateAlarm: EventEmitter<VariableAlarmWithTranslations | null> =
        new EventEmitter<VariableAlarmWithTranslations | null>();
}
